'use client';

import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { screenSmMin, screenXsMax } from '@spotify-internal/encore-foundation';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { cssColorValue, cssSpacing, semanticColors } from "../../styles/index.mjs";
import { Container as Controls } from "../PaginationControls/Container.mjs";
import styled from "../../styled-components.mjs";
var TablePaginationElement = styled.div.withConfig({
  displayName: "TablePagination__TablePaginationElement",
  componentId: "sc-8k.mjsb-0"
})(["color:", ";display:flex;align-items:center;@media (max-width:", "){padding-inline:", ";padding-block:", ";}@media (min-width:", "){padding:", ";}", "{flex:1;display:flex;justify-content:flex-end;}"], cssColorValue(semanticColors.textSubdued), screenXsMax, cssSpacing('tighter-4', '4px'), cssSpacing('tighter', '12px'), screenSmMin, cssSpacing('tighter', '12px'), Controls);

/**
 * TablePagination adds pagination controls to your table.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-table-tablepagination--docs) |
 * [Encore site](https://encore.spotify.net/web/components/table#pagination) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/TablePagination) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=20339-15574&t=3LLzJ2F0IcvY2bkk-1)
 */
export var TablePagination = /*#__PURE__*/React.forwardRef(function TablePagination(_ref, ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement(TablePaginationElement, Object.assign({}, props, {
    ref: ref,
    "data-encore-id": ENCORE_DATA_IDS.TablePagination
  }));
});